<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content pa-0"
    fluid
  >
    <v-row class="alternatingContentRow pa-0"></v-row>
    <v-row class="alternatingContentRow">
      <v-col class="center my-8 py-8" cols="12">
        <h1 class="text-center colorPrimary">Mijn overzicht</h1>
        <v-row justify="center" class="mt-4">
          <v-col cols="12" lg="10" xl="8">
            <p class="text-center px-4">
              U krijgt een overzicht van wat u reeds behandeld hebt in uw persoonlijke account.<br/>
              Zo kan u indien nodig eenvoudig wijzigingen aanbrengen of informatie toevoegen.<br/>
              Onderdelen die goedgekeurd zijn, kunnen enkel na telefonisch contact mogelijk nog aangepast worden.<br/>
              We helpen u steeds graag verder.
            </p>
          </v-col>
        </v-row>

        <v-row justify="center" class="mt-8">
          <!-- Left Column: Raadplegen -->
          <v-col cols="12" md="5" lg="4" class="px-4">
            <h2 class="text-center colorPrimary mb-6">Raadplegen</h2>

            <div v-for="(item, index) in raadplegenItems" :key="index" class="raadplegen-item">
              <v-row align="center" no-gutters>
                <v-col cols="8" class="text-left">
                  <span class="item-title">{{ item.title }}</span>
                </v-col>
                <v-col cols="4" class="text-right">
                  <v-btn
                    :to="item.disabled ? undefined : item.route"
                    color="secondary"
                    size="small"
                    variant="flat"
                    class="text-white"
                    :disabled="item.disabled"
                  >
                    bekijken
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>

          <!-- Right Column: Samenstellen -->
          <v-col cols="12" md="5" lg="4" class="px-4">
            <h2 class="text-center colorPrimary mb-6">Samenstellen</h2>

            <v-expansion-panels v-model="expandedPanels" multiple variant="accordion" class="overview-panels">
              <v-expansion-panel
                v-for="(item, index) in samenstellenItems"
                :key="index"
                :value="index"
                elevation="0"
                class="overview-item mb-4"
              >
                <v-expansion-panel-title class="px-0 py-4 overview-item-header" :hide-actions="!item.expandedContent || item.expandedContent.length === 0">
                  <v-row align="center" no-gutters>
                    <v-col cols="1" class="text-left">
                      <v-icon v-if="item.expandedContent && item.expandedContent.length > 0" size="small" color="primary" class="chevron-icon">mdi-chevron-right</v-icon>
                    </v-col>
                    <v-col cols="5" class="text-left">
                      <span class="item-title">{{ item.title }}</span>
                    </v-col>
                    <v-col cols="2" class="text-center">
                      <v-icon v-if="item.isLocked" size="small" color="secondary">mdi-lock</v-icon>
                      <v-icon v-else size="small" color="secondary">mdi-lock-open-variant</v-icon>
                    </v-col>
                    <v-col cols="4" class="text-right">
                      <v-btn
                        :color="item.buttonColor"
                        size="small"
                        variant="flat"
                        class="text-white status-button"
                        @click.stop
                      >
                        {{ item.buttonText }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-expansion-panel-title>

                <v-expansion-panel-text v-if="item.expandedContent && item.expandedContent.length > 0" class="pa-0 pt-2">
                  <div class="expanded-content">
                    <!-- Nested items with sub-sections -->
                    <div v-for="(subItem, subIndex) in item.expandedContent" :key="subIndex" class="sub-item mb-3">
                      <v-row align="center" no-gutters class="mb-2">
                        <v-col cols="6" class="text-left">
                          <span class="sub-item-title">{{ subItem.title }}</span>
                        </v-col>
                        <v-col cols="6" class="text-right">
                          <v-btn
                            v-if="subItem.buttonText"
                            :color="subItem.buttonColor || '#907322'"
                            size="x-small"
                            variant="flat"
                            class="text-white status-button"
                          >
                            {{ subItem.buttonText }}
                          </v-btn>
                        </v-col>
                      </v-row>

                      <!-- Additional details -->
                      <div v-if="subItem.details" class="sub-item-details ml-2">
                        <div v-for="(detail, detailIndex) in subItem.details" :key="detailIndex" class="detail-line">
                          <span class="detail-label">{{ detail.label }}:</span>
                          <span class="detail-value">{{ detail.value }}</span>
                        </div>
                      </div>

                      <!-- Images (for bloemen, etc.) -->
                      <div v-if="subItem.image" class="sub-item-image mt-2">
                        <v-img :src="subItem.image" :alt="subItem.title" max-width="80" class="rounded"></v-img>
                        <span v-if="subItem.price" class="detail-value">{{ subItem.price }}</span>
                      </div>

                      <!-- Simple text content -->
                      <div v-if="subItem.content" class="sub-item-content ml-2">
                        <p class="detail-value mb-1">{{ subItem.content }}</p>
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import authenticationMixin from '@/mixins/authenticationMixin'
import commonMixin from '@/mixins/commonMixin'
import errorMixin from '@/mixins/errorMixin'
import klantService from '@/services/klantService'

export default {
  name: 'MijnOverzicht',
  mixins: [authenticationMixin, commonMixin, errorMixin],
  data() {
    return {
      dossier: null,
      expandedPanels: [],
      raadplegenItems: [
        {
          title: 'condoleances',
          route: 'Condoleances',
          disabled: false
        },
        {
          title: 'aanwezigen koffietafel',
          route: 'Koffietafel',
          disabled: false
        },
        {
          title: 'video uitvaart',
          route: 'Video',
          disabled: true
        },
        {
          title: 'maatregelen COVID-19',
          route: 'MaatregelenCovid19',
          disabled: true
        }
      ],
      samenstellenItems: []
    }
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    klantService.Init(this)
    this.GetDossier()
  },
  methods: {
    async GetDossier() {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await klantService.GetDossier()

      if (resp && (resp.data || resp.data !== '')) {
        this.dossier = resp.data

        if (this.dossier && this.dossier.idDossier) {
          await this.GetOpvolgingTaken(this.dossier.idDossier)
        }
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    async GetOpvolgingTaken(idDossier) {
      const resp = await klantService.GetDossierOpvolgingFamilieTaakList(idDossier)

      if (resp && resp.data) {
        this.samenstellenItems = this.MapOpvolgingToSamenstellenItems(resp.data)
      }
    },
    MapOpvolgingToSamenstellenItems(apiData) {
      if (!apiData || !Array.isArray(apiData)) {
        console.warn('API data is not an array:', apiData)
        return this.samenstellenItems // Return default items if no valid data
      }

      return apiData.map(item => {
        const title = item.opvolgingFamilieTaak?.beschrijving || ''
        return {
          arrow: true,
          title: title.toLowerCase(),
          isLocked: item.uitgevoerd === true, // true = locked, false = unlocked
          buttonText: this.GetButtonText(item),
          buttonColor: this.GetButtonColor(item),
          expandedContent: this.MapExpandedContent(item)
        }
      })
    },
    MapExpandedContent(item) {
      // Check if there are sub-items or details to expand
      if (item.subItems || item.subTaken || item.details) {
        const subData = item.subItems || item.subTaken || item.details

        if (Array.isArray(subData)) {
          return subData.map(subItem => ({
            title: subItem.omschrijving || subItem.naam || subItem.title || '',
            buttonText: this.GetButtonText(subItem),
            buttonColor: this.GetButtonColor(subItem),
            content: subItem.content || subItem.inhoud || '',
            details: subItem.details || null,
            image: subItem.image || subItem.afbeelding || null,
            price: subItem.price || subItem.prijs || null
          }))
        }
      }

      return null
    },
    GetButtonText(item) {
      // Check if task is executed
      if (item.uitgevoerd === true || item.datumUitgevoerd !== null) {
        return 'goedgekeurd'
      } else if (item.opmerking !== null && item.opmerking !== '') {
        return 'nakijken/goedkeuren'
      } else {
        return 'in/aanvullen'
      }
    },
    GetButtonColor(item) {
      // Check if task is executed
      if (item.uitgevoerd === true || item.datumUitgevoerd !== null) {
        return '#6B8E6F' // Green - goedgekeurd
      } else if (item.opmerking !== null && item.opmerking !== '') {
        return '#907322' // Brown - nakijken/goedkeuren
      } else {
        return '#DEC067' // Light yellow/beige - in/aanvullen
      }
    }
  }
}
</script>

<style scoped>
/* Raadplegen items styling */
.raadplegen-item {
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  padding: 16px 0;
  margin-bottom: 16px;
}

.raadplegen-item:not(:first-child) {
  margin-top: -1px;
}

/* Overview panels styling */
.overview-panels {
  background: transparent;
}

.overview-item {
  border-bottom: 1px solid #e0e0e0;
  background: transparent !important;
}

.overview-item:first-child {
  border-top: 1px solid #e0e0e0;
}

.overview-item-header {
  padding: 16px 0;
  min-height: auto !important;
}

.overview-item-header:hover {
  background: transparent;
}

/* Hide default expansion panel icon */
:deep(.v-expansion-panel-title__icon) {
  display: none;
}

/* Chevron rotation when expanded */
:deep(.v-expansion-panel--active) .chevron-icon {
  transform: rotate(90deg);
  transition: transform 0.3s ease;
}

.chevron-icon {
  transition: transform 0.3s ease;
}

.item-title {
  font-size: 0.95rem;
  color: #424E58;
}

.status-button {
  font-size: 0.75rem;
  text-transform: none;
  letter-spacing: normal;
}

/* Expanded content styling */
.expanded-content {
  padding: 8px 0 12px 24px;
  background: #f9f9f9;
  border-radius: 4px;
  margin-left: 12px;
}

.sub-item {
  border-bottom: 1px solid #e8e8e8;
  padding: 8px 0;
}

.sub-item:last-child {
  border-bottom: none;
}

.sub-item-title {
  font-size: 0.85rem;
  color: #424E58;
  font-weight: 500;
}

.sub-item-details {
  font-size: 0.8rem;
  color: #666;
}

.detail-line {
  display: flex;
  gap: 8px;
  margin-bottom: 2px;
}

.detail-label {
  font-weight: 500;
  color: #666;
}

.detail-value {
  color: #424E58;
}

.sub-item-content {
  font-size: 0.85rem;
  color: #666;
}

.sub-item-image {
  display: flex;
  align-items: center;
  gap: 12px;
}

h2 {
  font-size: 1.3rem;
  font-weight: 500;
}
</style>
